export const CONTEXT_MENU_CELL_ID = 'contextMenu';
export const SELECT_CELL_ID = 'ag-Grid-SelectionColumn';
export const GROUP_CELL_ID = 'groupId';

// Pinned in code, so stored view state must leave them alone.
export const FIXED_COL_IDS: string[] = [SELECT_CELL_ID, CONTEXT_MENU_CELL_ID];

// Widths persist per user now, so a declared minWidth is only the drag floor --
// what a column opens at still comes from its width or flex.
export const MIN_COLUMN_WIDTH = 64;

// Free text that reads badly squeezed, so it opens at twice a plain column's
// share instead of at a declared width its neighbours' flex then dwarfs.
export const WIDE_COL_IDS: string[] = ['name', 'commitMessage'];
export const WIDE_COLUMN_FLEX = 2;
